export type Theme = 'default' | 'thoughtworks';

const theme = (import.meta.env.VITE_THEME as Theme) ?? 'default';
document.documentElement.setAttribute('data-theme', theme);
